// src/redux/settings/settingsSelectors.js

// ✅ Get Admin Profile Selectors
export const selectAdminProfileData = (state) => state?.settings?.getAdminProfile?.data;
export const selectAdminProfileLoading = (state) => state?.settings?.getAdminProfile?.loading;
export const selectAdminProfileError = (state) => state?.settings?.getAdminProfile?.error;

// ✅ Update Admin Profile Selectors
export const selectUpdateAdminProfileData = (state) => state?.settings?.updateAdminProfile?.data;
export const selectUpdateAdminProfileLoading = (state) => state?.settings?.updateAdminProfile?.loading;
export const selectUpdateAdminProfileError = (state) => state?.settings?.updateAdminProfile?.error;

// ✅ Upload Profile Image Selectors
export const selectUploadProfileImageData = (state) => state?.settings?.uploadProfileImage?.data;
export const selectUploadProfileImageLoading = (state) => state?.settings?.uploadProfileImage?.loading;
export const selectUploadProfileImageError = (state) => state?.settings?.uploadProfileImage?.error;

// ✅ Delete Profile Image Selectors
export const selectDeleteProfileImageData = (state) => state?.settings?.deleteProfileImage?.data;
export const selectDeleteProfileImageLoading = (state) => state?.settings?.deleteProfileImage?.loading;
export const selectDeleteProfileImageError = (state) => state?.settings?.deleteProfileImage?.error;

// ✅ Change Password Selectors
export const selectChangePasswordData = (state) => state?.settings?.changePassword?.data;
export const selectChangePasswordLoading = (state) => state?.settings?.changePassword?.loading;
export const selectChangePasswordError = (state) => state?.settings?.changePassword?.error;
// ✅ Upload Company Logo Selectors
export const selectUploadCompanyLogoData = (state) => state?.settings?.uploadCompanyLogo?.data;
export const selectUploadCompanyLogoLoading = (state) => state?.settings?.uploadCompanyLogo?.loading;
export const selectUploadCompanyLogoError = (state) => state?.settings?.uploadCompanyLogo?.error;

// ✅ Delete Company Logo Selectors
export const selectDeleteCompanyLogoData = (state) => state?.settings?.deleteCompanyLogo?.data;
export const selectDeleteCompanyLogoLoading = (state) => state?.settings?.deleteCompanyLogo?.loading;
export const selectDeleteCompanyLogoError = (state) => state?.settings?.deleteCompanyLogo?.error;

// ✅ Complete Settings State
export const selectSettingsState = (state) => state?.settings;